





































































import { Vue, Component, Prop } from 'vue-property-decorator'
import EditForm from '@/components/EditForm.vue'

const fields = `
	id
	type
	SKU
	Device
	ReleaseDate
	ReleaseVersion
	ReleaseApp
	ReleaseLoader
	ReleaseFont
	ReleaseScreen
	MinHardwareVersion
	MaxHardwareVersion
	ArchiveName
	ShortDescription
	LongDescription
	Live
	PartNumVersion
`

@Component({ components: { EditForm } })
export default class FirmwareForm extends Vue {

	@Prop() firmware
	@Prop() products!: Array<{ id: string }>

	get deviceOptions() {
		return this.products.map(product => ({ value: product.id, text: product.id }))
	}

	typeOptions = [{ value: 'Legacy', text: 'Legacy' }, { value: 'Paid', text: 'Paid' }]
	liveOptions = [{ value: true, text: 'True' }, { value: false, text: 'False' }]

	defaultFirmware = {
		id: '',
		type: '',
		SKU: '',
		Device: '',
		ReleaseDate: '',
		ReleaseVersion: '',
		ReleaseApp: '',
		ReleaseLoader: '',
		ReleaseFont: '',
		ReleaseScreen: '',
		MinHardwareVersion: '',
		MaxHardwareVersion: '',
		ArchiveName: '',
		ShortDescription: '',
		LongDescription: '',
		Live: false,
		PartNumVersion: ''
	}

	createFirmware = `mutation CreateFirmware($input: CreateFirmwareInput!) {
		createFirmware(input: $input) { ${ fields } }
	}`
	updateFirmware = `mutation UpdateFirmware($input: UpdateFirmwareInput!) {
		updateFirmware(input: $input) { ${ fields } }
	}`
	deleteFirmware = `mutation DeleteFirmware($id: ID!) {
		deleteFirmware(id: $id) { ${ fields } }
	}`

}
